export enum MembershipType { Associated, Connected }
